import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useContext, useEffect, useState} from "react";
import {
    faCaretDown,
    faCaretRight
} from "@fortawesome/free-solid-svg-icons";

import "../styles/TemplateDivisionTypeElement.css";
import {findDivisionType} from "../pages/MapTemplateEditor";
import {MapContext} from "../pages/MapEditor";
import DivisionElement from "./DivisionElement";

const InlineIconButton = ({ icon, onClick, style }) => {
    return <div style={style} className="InlineIconButton" onClick={onClick}><FontAwesomeIcon icon={icon}/></div>;
}

const DivisionTypeElement = ({ id, parentOpen = true, hoist = 0 }) => {
    const [ open, setOpen ] = useState(false);

    const { template } = useContext(MapContext);
    const [ data, setData ] = useState(null);

    useEffect(() => setData(findDivisionType(id, template)), [id, template]);

    if (parentOpen === false && open) setOpen(false);

    if (!data) return;

    if (!data.result.topLevel && !data.result.divisions?.length) return;

    if (data.depth === 0 && data.result.divisions?.length === 1) {
        const division = data.result.divisions[0];

        return <DivisionElement key={division.id} id={division.id} parentOpen={parentOpen} hoist={1}/>;
    }

    return (
        <>
            <div className="TemplateDivisionTypeElement">
                <div className="self" tabIndex={0} style={{ paddingLeft: ((1 + data.depth - hoist) * 20) + 'px' }} onContextMenu={e => e.preventDefault()}>
                    <InlineIconButton icon={ open ? faCaretDown : faCaretRight } onClick={() => setOpen(!open)}
                                      style={{ opacity: data.result.division_types?.length || data.result.divisions?.length ? '100%' : 0 }}/>
                    <p className="name">{data.result.divisions?.length ? data.result.pluralName : data.result.name}</p>
                </div>
                <div className="children" style={{ display: open ? "block" : "none" }}>
                    {data.result.division_types?.map(divisionType => <DivisionTypeElement key={divisionType.id} parentOpen={open} id={divisionType.id}/>)}
                    {data.result.divisions?.map(division => <DivisionElement key={division.id} id={division.id} parentOpen={open}/>)}
                </div>
            </div>
        </>
    );
}

export default DivisionTypeElement;
